import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
 

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import('@/pages/index/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/formations",
    name: "formations",
    component: () => import('@/pages/formations/formation.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/item-detail",
    name: "item-details",
    component: () => import('@/pages/formations/item-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/item-detail/:id",
    name: "item-detail",
    component: () => import('@/pages/formations/item-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/formation/:id",
    name: "formation-detail",
    component: () => import('@/pages/formations/item-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/vr/:id",
    name: "vr-detail",
    component: () => import('@/pages/vr-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/ajouterFormation",
    name: "ajouterFormation",
    component: () => import('@/pages/formations/ajouterFormation.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/services",
    name: "services",
    component: () => import('@/pages/services/dev.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/reservation",
    name: "reservation",
    component: () => import('@/pages/reservation.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/partner",
    name: "partners",
    component: () => import('@/pages/partner.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/partner/:id",
    name: "partner",
    component: () => import('@/pages/partner.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/Evenements",
    name: "Evenements",
    component: () => import('@/pages/event.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/Evenements/:id",
    name: "Evenement",
    component: () => import('@/pages/event.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/Offres",
    name: "Offres",
    component: () => import('@/pages/offre.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/service/:id",
    name: "service",
    component: () => import('@/pages/services/dev.vue'),
    meta: { requiresAuth: true }
  },
/*   {
    path: "/notif-push",
    name: "notif-push",
    component: () => import('@/pages/services/notif-push.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/erp",
    name: "erp",
    component: () => import('@/pages/services/erp.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/cloud",
    name: "cloud",
    component: () => import('@/pages/services/cloud.vue'),
    meta: { requiresAuth: true }
  },*/
  {
    path: "/newsletter",
    name: "newsletter",
    component: () => import('@/pages/newsletter.vue'),
    meta: { requiresAuth: true }
  }, 
  {
    path: "/messages",
    name: "messages",
    component: () => import('@/pages/message.vue'),
    meta: { requiresAuth: true }
  }, 
  {
    path: "/messages/:id",
    name: "message",
    component: () => import('@/pages/message.vue'),
    meta: { requiresAuth: true }
  }, 
  {
    path: "/notifications",
    name: "notifications",
    component: () => import('@/pages/notifications.vue'),
    meta: { requiresAuth: true }
  }, 
  {
    path: "/notification/:id",
    name: "notification",
    component: () => import('@/pages/notifications.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/ajouterVr",
    name: "ajouterVr",
    component: () => import('@/pages/ajouterVr.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/auction",
    name: "live-auction",
    component: () => import('@/pages/live-auction.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/wallet",
    name: "wallet",
    component: () => import('@/pages/wallet.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/vr",
    name: "vr",
    component: () => import('@/pages/vr.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/users",
    name: "users",
    component: () => import('@/pages/creators/users.vue'),
    meta: { requiresAuth: true }
  }, 
  {
    path: "/user-profile/:id",
    name: "user-profile",
    component: () => import('@/pages/creators/user-profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/update-profile/:id",
    name: "update-profile",
    component: () => import('@/pages/creators/update-profile.vue'),
    meta: { requiresAuth: true }
  }, 
  {
    path: "/add-user",
    name: "add-user",
    component: () => import('@/pages/creators/become-creator.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import('@/pages/blog/blog.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/blog-detail",
    name: "blog-details",
    component: () => import('@/pages/blog/blog-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/blog-detail/:id",
    name: "blog-detail",
    component: () => import('@/pages/blog/blog-detail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/starter",
    name: "starter",
    component: () => import('@/pages/pages/starter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/faqs",
    name: "faqs",
    component: () => import('@/pages/pages/faqs.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import('@/pages/pages/privacy.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import('@/pages/pages/terms.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "login",
    component: () => import('@/pages/auth-pages/login.vue'),
    meta: { checkUser: true }
  },
 
  {
    path: "/signup-success",
    name: "signup-success",
    component: () => import('@/pages/auth-pages/signup-success.vue'),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import('@/pages/auth-pages/reset-password.vue'),
  },
  {
    path: "/lock-screen",
    name: "lock-screen",
    component: () => import('@/pages/auth-pages/lock-screen.vue'),
  },
  {
    path: "/comingsoon",
    name: "comingsoon",
    component: () => import('@/pages/miscellaneous/comingsoon.vue'),
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => import('@/pages/miscellaneous/maintenance.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: "/thankyou",
    name: "thankyou",
    component: () => import('@/pages/miscellaneous/thankyou.vue'),
  },
  {
    path: "/:error(.*)",
    name: "error-last",
    component: () => import('@/pages/miscellaneous/error.vue'),
  },
  {
    path: "/error/:errorCode",
    name: "error",
    component: () => import('@/pages/miscellaneous/error.vue'),
  },

];


const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()

  if (to.meta.requiresAuth && !userStore.userId) {
    await userStore.fetchUser()

    if (userStore.userId === 0) {
       return next({ name: 'login' }) 
    }
    
  }

  if (to.meta.checkUser) {
    await userStore.fetchUser() 
    if (userStore.userId !== 0) {
      return next({ name: 'index' }) 
    }
  }

  next()
})



export default router;